import { render } from "./EditarMaterial.vue?vue&type=template&id=123d5159"
import script from "./EditarMaterial.vue?vue&type=script&lang=js"
export * from "./EditarMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__